import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import AdventistIcon from "./AdventistIcon";

import styles from "./AdventistContainer.module.scss";

const AdventistContainer = ({
  textMode = false,
  className,
  link = "adventist.org",
  iconSrc,
  hideLinkLabel,
}) => {
  return (
    <div className={classNames(styles["adventistContainer"], className)}>
      <a
        className={styles["adventistIconContainer"]}
        href={`https://www.${link}/`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {!textMode && !iconSrc && <AdventistIcon className={styles["footerADVIcon"]} />}
        {!textMode && iconSrc && <img src={iconSrc} className={styles["footerADVIcon"]} />}

        {!hideLinkLabel && <span>{link}</span>}
      </a>
    </div>
  );
};

AdventistContainer.propTypes = {
  textMode: PropTypes.bool,
  className: PropTypes.string,
};

export default AdventistContainer;
